import { render } from "./SelectField.vue?vue&type=template&id=08ca2c54&ts=true"
import script from "./SelectField.vue?vue&type=script&lang=ts"
export * from "./SelectField.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./SelectField.vue?vue&type=style&index=1&id=08ca2c54&lang=css"

import exportComponent from "../../../../../../ss/AZ/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__